import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function TheDragonsBreath() {
  return <section data-section-id="236490" id="amplify-your-atmosphere" className="relative w-full h-[600px] flex items-center justify-center overflow-hidden bg-[#050505] text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672919/img/Copy of Really excited to get in touch with us Send us an email at info@pulseav.co.uk Or follow us at @pulse_av_ on Instagram (1).png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672919/img/Copy of Really excited to get in touch with us Send us an email at info@pulseav.co.uk Or follow us at @pulse_av_ on Instagram (1).png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672919/img/Copy of Really excited to get in touch with us Send us an email at info@pulseav.co.uk Or follow us at @pulse_av_ on Instagram (1).png-wvc-sizes" alt="Pulse AV Event Production" className="w-full h-full object-cover opacity-50" loading="lazy" decoding="async" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/80 via-transparent to-[#050505]" />
      </div>

      {}
      <div className="relative z-20 flex flex-col items-center text-center px-6 w-full max-w-6xl mx-auto">
        {}
        

        {}
        <h1 className="font-default text-6xl sm:text-8xl md:text-9xl lg:text-[110px] leading-[0.9] font-black tracking-tighter text-white mb-8 uppercase">Bringing Your <br />Events to <span className="text-primary tracking-[-2px]">&nbsp;LIFE</span></h1>

        {}
        <p className="font-default text-lg md:text-2xl text-slate-400 max-w-2xl mb-16 tracking-wide">Professional Audio Visual Solutions</p>

        {}
        <div className="flex flex-col sm:flex-row gap-6 items-center">
          <Link to="/GetAQuotePage">
            
          </Link>
          
          <Link to="/CorporateLivePage">
            
          </Link>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
      <div className="absolute top-1/4 -left-20 w-64 h-64 bg-primary/10 rounded-lg blur-[120px]" />
      <div className="absolute bottom-1/4 -right-20 w-64 h-64 bg-chart-3/10 rounded-lg blur-[120px]" />
    </section>;
}